/* src/app/shared/ui-kit/pa-router-tabs/pa-router-tabs.component.scss */
:host ::ng-deep .pa-router-tabs .p-tab {
  border: none;
}
/*# sourceMappingURL=pa-router-tabs.component.css.map */
